export const environment = {
  debug: false,
  hmr: false,
  production: true,
  version: require("../../scripts/package.json").version,
};
